<template>
  <div v-if="imgLoading" class="jigsawcha-loading">
    <div class="xl-button__text">
      <i class="xl-button__loading"></i>
    </div>
  </div>
  <template v-else-if="imgs.length > 1">
    <div class="zy-jigsawcha-box" @touchmove.prevent>
      <img class="jigsawcha-img" :src="imgs[1]"  alt="" />
      <div class="jigsawcha-overlay"></div>
      <img class="jigsawcha-puzzle" :src="imgs[0]" :style="{left: slideWidth+'px'}" alt="" />
      <div class="jigsawcha-tip" :class="{ 'fail': verifyFail, 'success': verifySuccess }" :style="verifyFail || verifySuccess ? 'bottom:0;opacity:1;' : '' ">{{ verifySuccess ? ($t('vSliderSuccessText') || '验证通过') : ( verifyFail? ( $t('gridcha.verifyFail') || '验证失败, 请重试') : '' ) }}</div>
    </div>
    <div class="jigsawcha-verify-body" ref="verifyBodyRef" @touchmove.prevent>
      <div class="jigsawcha-verify-left" :class="{ 'fail': verifyFail }" :style="{width: slideWidth+'px'}"></div>
      <div class="jigsawcha-verify-slider" :class="{ 'fail': verifyFail, 'success': verifySuccess, 'slider-move': !moveing }" ref="verifyRef" id="jigsawcha-slider" @mousedown="mouseDownHandler($event)" :style="{left: slideWidth+'px'}">
        <div class="xl-button__text" v-if="loading">
          <i class="xl-button__loading"></i>
        </div>
        <i class="xl-icon icon iconfont" v-else-if="verifyFail" style="font-size: 16px; line-height: 16px;">
          <ErrorDelect />
        </i>
        <i class="xl-icon icon iconfont" v-else-if="verifySuccess" style="font-size: 16px; line-height: 16px;">
          <Wancheng />
        </i>
        <i class="xl-icon icon iconfont" v-else style="font-size: 16px; line-height: 16px;">
          <DArrowRight />
        </i>
      </div>
      <div class="jigsawcha-verify-text-box">
        <span class="jigsawcha-verify-text">{{ verifyInit ? ( $t('pleaseVerificationCode') || '请拖动滑块，以获取验证码') : '' }}</span>
      </div>
    </div>
  </template>
</template>
 
<script setup>
import { defineProps, defineEmits, ref, onMounted, nextTick, onBeforeUnmount } from 'vue';
import { useLang, useIndependentLang } from "../util/lang";

import { DArrowRight, ErrorDelect, Wancheng } from '@shining3d/icons-vue'

const props = defineProps({
  reload: {
    type: Boolean,
    default: false
  },
  scene: {
    type: String,
    default: 'register'
  },
  imgLoading: {
    type: Boolean,
    default: false
  },
  customLang: String
});

let { $t } = useLang("@shining3d/xl-login");
if ( props.customLang ) {
  $t = useIndependentLang("@shining3d/xl-login", props.customLang).$t;
}

const emit = defineEmits([ 'resetInit', 'captchaCheckBack', 'zyShakeShow']);

const loading = ref(false);
const reloadFn = () => {
  canSlide.value = false;
  moveing.value = false;
  verifySuccess.value = false;
  verifyFail.value = false;
  verifyInit.value = true;
  slideWidth.value = 0;
}

const imgs = ref([]);

function initData(obj){
  if(obj.imgs && obj.imgs.length > 0){
    const imgsTemp = obj.imgs.map((item) => {
      return 'data:image/png;base64,' + item;
    });
    imgs.value = imgsTemp;
    nextTick(() => {
      updateMaxWidth();
      addListenerRef();
    })
  }
}
const moveing = ref(false); // 滑块中
const canSlide = ref(false); // 滑块是否可以移动
const verifySuccess = ref(false); // 是否验证成功
const verifyFail = ref(false); // 是否验证成功
const verifyInit = ref(true); // 是否验证成功
const beginTouchX = ref(0); // 触摸开始的位置
const beginTouchY = ref(0); // 触摸开始的位置
const beginPageX = ref(0); // 鼠标按下的位置
const maxWidth = ref(0); // 滑块验证成功需要移动的最大距离
const slideWidth = ref(0); // 滑块滑过的区域宽度
const verifyBodyRef = ref(null);
const verifyRef = ref(null);

const mouseDownHandler = (e) => {
  if (!verifySuccess.value && !verifyFail.value) {
    canSlide.value = true;
    verifyInit.value = false;
    beginPageX.value = e.pageX;
  }
}
const mouseMoveHandler = (e) => {
  if (canSlide.value) {
    moveing.value = true;
    const width = e.pageX - beginPageX.value;
    if (width > 0 && width <= maxWidth.value) {
      slideWidth.value = width;
    }
  }
}
const mouseUpHandler = (e) => {
  if(moveing.value){
    const palNum = Math.round(((slideWidth.value / maxWidth.value) * 100))/100;
    if(palNum <= 0.1){
      verifyInit.value = true;
      moveing.value = false;
      canSlide.value = false;
      slideWidth.value = 0;
    } else {
      canSlide.value = false;
      moveing.value = false;
      statusChange(palNum);
    }
  } else {
    verifyInit.value = true;
    canSlide.value = false;
    slideWidth.value = 0;
  }
}
const removeListener = () => {
  const html = document.getElementsByTagName('html')[0];
  html.removeEventListener('mousemove', mouseMoveHandler);
  html.removeEventListener('mouseup', mouseUpHandler);
}

const touchStartHandler = (e) => {
  if (!verifySuccess.value && e.touches.length === 1) {
    canSlide.value = true;
    beginTouchX.value = e.touches[0].clientX;
    beginTouchY.value = e.touches[0].clientY;
  }
}

const touchMoveHandler = (e) => {
  if (canSlide.value && e.touches.length === 1) {
    verifyInit.value = false;
    moveing.value = true;
    const width = e.touches[0].clientX - beginTouchX.value;

    const moveX = e.targetTouches[0].pageX;
    const moveY = e.targetTouches[0].pageY;

    if (Math.abs(moveX - beginTouchX.value) > Math.abs(moveY - beginTouchY.value)) {
      e.preventDefault();
    }

    if (width > 0 && width <= maxWidth.value) {
      slideWidth.value = width;
    }
  }
}
const updateMaxWidth = () => {
  if (verifyBodyRef.value && verifyRef.value) {
    maxWidth.value = verifyBodyRef.value.offsetWidth - verifyRef.value.offsetWidth - 4; // (4是padding-left)
  }
}
const touchEndHandler = (e) => {
  if(moveing.value){
    const palNum = Math.round(((slideWidth.value / maxWidth.value) * 100))/100;
    if(palNum <= 0.1){
      verifyInit.value = true;
      moveing.value = false;
      canSlide.value = false;
      slideWidth.value = 0;
    } else {
      canSlide.value = false;
      moveing.value = false;
      statusChange(palNum);
    }
  } else {
    verifyInit.value = true;
    canSlide.value = false;
    slideWidth.value = 0;
  }
}

const removeListRef = () => {
  if(verifyBodyRef.value && verifyRef.value){
    verifyRef.value.removeEventListener('touchstart', touchStartHandler);
    verifyRef.value.removeEventListener('touchmove', touchMoveHandler);
    verifyRef.value.removeEventListener('touchend', touchEndHandler);
  }
}

const addListenerRef = () => {
  removeListRef();
  if(verifyBodyRef.value && verifyRef.value){
    verifyRef.value.addEventListener('touchstart', touchStartHandler, { passive: false });
    verifyRef.value.addEventListener('touchmove', touchMoveHandler, { passive: false });
    verifyRef.value.addEventListener('touchend', touchEndHandler);
  }
}

const addListener = () => {
  const html = document.getElementsByTagName('html')[0];
  html.addEventListener('mousemove', mouseMoveHandler);
  html.addEventListener('mouseup', mouseUpHandler);
}

const putFail = () => {
  verifyFail.value = true;
  emit('zyShakeShow');
}

const statusChange = (num) => {
  loading.value = true;
  emit('captchaCheckBack', {
    data: num.toString(),
    callback: (res) => {
      loading.value = false;
      if(!res){
        // 抖动
        putFail();
        // 2s后重新获取，重置
        setTimeout(() => {
          emit('resetInit', () => {
            reloadFn();
          }, true );
        }, 2000);
      } else {
        verifySuccess.value = true;
      }
    }
  })
}
// watch(() => props.reload, (newV, oldV) => {
//   if (newV) {
//     reloadFn();
//   }
// });

onMounted(() => {
  addListener();
})

onBeforeUnmount(() => {
  removeListener();
  removeListRef();
})

defineExpose({initData});
</script>
<style lang="scss" scoped>
.zy-jigsawcha-box{
  height: 200px;
  position: relative;
  background: rgba(0, 0, 0, .08);
  border-radius: 5px;
  margin: 8px 0;
  overflow: hidden;
  width: 300px;
  img{
    user-select: none;
    -webkit-user-drag: none;
    animation: fadeIn .5s ease-in-out forwards;
  }
}
.jigsawcha{
  &-img{
    left: 0;
    margin: 0 auto;
    position: absolute;
    top: 0;
    width: 300px;
    height: 200px;
  }
  &-overlay{
    background-color: hsla(0, 0%, 100%, .5);
    display: none;
    height: 100%;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
  }
  &-puzzle{
    margin: 0 auto;
    position: absolute;
    top: 0;
    height: 100%;
  }
  &-tip{
    bottom: -28px;
    color: #fff;
    font-size: 14px;
    left: 0;
    opacity: 0;
    padding-left: 4px;
    position: absolute;
    user-select: none;
    width: 100%;
    z-index: 999;
    transition: bottom .3s ease-out, opacity .3s ease-out;
    box-sizing: border-box;
    line-height: 1.5;
    &.fail {
      background-color: rgba(255,64,64,.8);
    }
    &.success {
      background-color: rgba(94,191,112,.6);
    }
  }
}
.jigsawcha-verify{
  &-body {
    background-color: #f5f5f5;
    border: 1px solid #e3e4e6;
    border-radius: 2px;
    height: 40px;
    margin: 0;
    padding: 0;
    position: relative;
    user-select: none;
  }
  &-left {
    border-radius: 2px 0 0 2px;
    height: 100%;
    position: absolute;
    background-color: #8fcc5c;
    &.fail{
      background-color: #FDEEEE;
    }
  }
  &-slider {
    background-color: #fff;
    border: 1px solid #e3e4e6;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .09);
    box-sizing: border-box;
    position: absolute;
    text-align: center;
    width: 40px;
    z-index: 2;
    pointer-events: all;
    cursor: grab;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;

    &.slider-move{
      transition: left .2s;
    }
    &.fail {
      background-color: #E64C4C;
      :deep(i.icon svg g){
        fill: #FFFFFF;
      }
    }
  }
  &-text-box {
    align-items: center;
    background: transparent;
    color: #b3b3b3;
    cursor: pointer;
    display: flex;
    font-size: 15px;
    font-weight: 400;
    height: 100%;
    justify-content: center;
    position: absolute;
    text-align: center;
    width: 100%;
    z-index: 1;
  }
  &-text {
    -webkit-text-fill-color: transparent;
    animation: slidingtext 6s linear infinite;
    background-clip: text;
    background-image: -webkit-gradient(linear, left top, right top, color-stop(0, #b3b3b3), color-stop(.4, #b3b3b3), color-stop(.5, #fff), color-stop(.6, #b3b3b3), color-stop(1, #b3b3b3));
    background-size: 300% 100%;
    width: 220px;
  }
}
.xl-button__text{
  width: 16px;
  display: block;
  height: 16px;
  .xl-button__loading {
    display: inline-block;
    height: 16px;
    margin: 0;
    margin-bottom: 10px;
    line-height: 1;
  }
}
@keyframes slidingtext {
  0% {
    background-position: 150% 0
  }

  to {
    background-position: -150% 0
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0
  }

  to {
    opacity: 1
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg)
  }

  to {
    transform: rotate(1turn)
  }
}
.jigsawcha-loading{
  width: 300px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, .1);
  border-radius: 6px;
  .xl-button__text{
    display: flex;
    .xl-button__loading{
      display: inline-block;
      height: 16px;
      margin: 0;
    }
  }
}
</style>